export default "__VITE_PUBLIC_ASSET__a6822ae6__"